<template>
  <div id="loader">
    <div class="default-spinner" :style="{ width: `${size}px`, height: `${size}px` }"></div>
  </div>
</template>

<script>
export default {
  name: 'CustomLoader',
  props: {
    size: {
      type: Number,
      default: 40,
    },
  },
};
</script>

<style scoped>
.default-spinner {
  border: 4px solid rgb(255 255 255 / 10%);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
